import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

declare global {
  interface Window {
    fbq?: (...args: unknown[]) => void;
  }
}

// SPA route-change PageView for Meta Pixel (init + first PageView fire in index.html).
export const useFacebookPixel = () => {
  const { pathname, search } = useLocation();

  useEffect(() => {
    window.fbq?.('track', 'PageView');
  }, [pathname, search]);
};
